import styled from 'styled-components';

export const SimpleHeaderWrapper = styled.div<{ hideBoxShadow?: boolean }>`
  width: 100%;
  max-height: 93px;
  height: 93px;
  background: ${({ theme }) => theme.palette.white};
  position: relative;
  box-shadow: ${({ hideBoxShadow }) =>
    hideBoxShadow
      ? 'inset 0 -1px 0 0 rgba(0, 0, 0, 0)'
      : 'inset 0 -1px 0 0 rgba(41, 42, 44, 0.15)'};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding: 20px 15px;
    justify-content: center;
  }
`;

export const SimpleHeaderContentWrapper = styled.div<{
  align?: 'flex-start' | 'center' | 'flex-end';
}>`
  height: 86px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: ${({ align }) => (align ? align : 'flex-start')};
  position: absolute;
  top: 50%;
  left: ${({ align }) => (align === 'flex-start' ? '150px' : '50%')};
  transform: translate(-50%, -50%);
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    left: 50%;
    justify-content: center;
    height: 64px;
    box-shadow: none;
    margin-left: 0;
  }
`;

export const SimpleHeaderLogo = styled.div`
  cursor: pointer;
`;
